import { spacingVars } from '@tundr/ds-foundations';
import { style } from '@vanilla-extract/css';

export const filtersSelectorWrapperClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: spacingVars.md,
  minWidth: 'fit-content',
});
